const UserSetup = {
    "clearways": {
        'navigation': {
            "admin": ["overview", "devices", "clearways", /*"crowds",*/ "operations"],
            "technician": ["overview", "devices", "clearways", /*"crowds",*/ "operations"],
            "editor": ["overview", "devices", "clearways"],//, "crowds" "operations"],
            "viewer": ["overview", "devices", "clearways"],//, "crowds" "operations"]
        },
        'device': {
            "admin": ["Overview", "LiveView", "Generate Report", "Statistics", "Events", "Camera Feed", "History", "Settings"],
            "technician": ["Overview", "LiveView", "Generate Report", "Statistics", "Events", "Camera Feed", "History", "Settings"],
            "editor": ["Overview", "LiveView", "Generate Report", "Statistics"],
            "viewer": ["Overview", "LiveView", "Generate Report"]
        },
        'group': {
            "admin": ["Overview", "Camera Feeds"],// "Group Settings"],
            "technician": ["Overview", "Camera Feeds"],// "Group Settings"],
            "editor": ["Overview"],
            "viewer": ["Overview"]
        }
    },
    "stopmonitor": {
        'navigation': {
            "admin": ["overview", "devices", /*"translations", */"media", "operations", "campaign_manager", "translations"],
            "technician": ["overview", "devices", /*"translations", "media",*/ "operations", "campaign_manager", "translations"],
            "editor": ["overview", "devices", /*"translations", "media",*/ "operations", "campaign_manager", "translations"],
            "viewer": ["overview", "devices", /*"translations", "media",*/ "operations"]
        },
        'device': {
            "admin": ["Overview", "LiveView", "Statistics", "Events", "Campaigns", "History", "Settings"],
            "technician": ["Overview", "LiveView", "Statistics", "Events", "Campaigns", "History", "Settings"],
            "editor": ["Overview", "LiveView", "Statistics", "Campaigns",],
            "viewer": ["Overview", "LiveView"]
        }
    },
    "translink-poc": {
        'navigation': {
            "admin": ["overview", "devices", "operations"],
            "technician": ["overview", "devices", "operations"],
            "editor": ["overview", "devices"],
            "viewer": ["overview", "devices"]
        },
        'device': {
            "admin": ["Overview", "LiveView", "Statistics", "Events", "Camera Feed", "History", "Settings"],
            "technician": ["Overview", "LiveView", "Statistics", "Events", "Camera Feed", "History", "Settings"],
            "editor": ["Overview", "LiveView", "Statistics", "Camera Feed"],
            "viewer": ["Overview", "LiveView"]
        }
    }
}

export default UserSetup;